import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET, } from '@voltmoney/schema';
import { ACTION } from './types';
import { goBackAction, needHelpAction, } from './actions';
import { ROUTE } from "../../routes";
import { Platform } from "react-native";
import { getDateMonthYearFromEpoch, getISTTime } from "../../configs/utils";
export const template = (height, stepperData) => ({
    layout: {
        id: ROUTE.TRACK_FORECLOSURE,
        type: LAYOUTS.LIST,
        widgets: [
            { id: "trackForeClosureDC", type: WIDGET.TRACK_FORECLOSURE_REQUEST },
        ],
    },
    datastore: {
        trackForeClosureDC: {
            height: height,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.TRACK_FORECLOSURE,
                payload: {}
            },
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.TRACK_FORECLOSURE,
                payload: {}
            },
            stepperData: stepperData
        }
    },
});
export const trackForeClosureMF = {
    onLoad: async ({ getHeight }, { data }) => {
        const createdOn = data?.createdOn;
        const createdOnDDMMYYY = getDateMonthYearFromEpoch(createdOn).slice(0, -6);
        const createdFullTimeAndDate = `${getISTTime(createdOn)}, ${createdOnDDMMYYY}`;
        const lastUpdatedDate = data?.lastUpdatedOn;
        const lastUpdatedOnDDMMYYY = getDateMonthYearFromEpoch(lastUpdatedDate).slice(0, -6);
        const lastUpdatedOnFullTimeAndDate = `${getISTTime(lastUpdatedDate)}, ${lastUpdatedOnDDMMYYY}`;
        const stepperData = [
            {
                "status": "COMPLETED",
                "verticalDisplayName": "Loan closure request accepted",
                "verticalDescription": `Placed by you at ${createdFullTimeAndDate}`,
                "order": 0,
                "highLightText": false
            },
            {
                "status": "COMPLETED",
                "verticalDisplayName": "Loan closure processed",
                "verticalDescription": `Loan closed at ${lastUpdatedOnFullTimeAndDate}`,
                "order": 1,
                "highLightText": false
            },
            {
                "status": "COMPLETED",
                "verticalDisplayName": "RTA(s) notified to remove pledge",
                "verticalDescription": Platform.OS !== "web" ?
                    "SEBI authorised RTAs (CAMS and KFintech)\nhave been notified to remove pledge from\nyour portfolio. It may take them 4-5 business\ndays."
                    : "SEBI authorised RTAs (CAMS and KFintech) have been notified to remove pledge from your portfolio. It may take them 4-5 business days.",
                "order": 2,
                "highLightText": true
            },
        ];
        return Promise.resolve(template(getHeight(), stepperData));
    },
    actions: {
        [ACTION.NEED_HELP]: needHelpAction,
        [ACTION.GO_BACK]: goBackAction
    },
    clearPrevious: true,
};
